"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultEmailHelpers = exports.StaticEmailHelpers = void 0;
class StaticEmailHelpers {
    static validateEmail(email, { emailRegex }) {
        return emailRegex.test(email);
    }
    static obfuscateEmail(email) {
        if (!email.trim()) {
            return '';
        }
        const emailSubSplits = email.split('@');
        const firstChar = emailSubSplits[0].charAt(0);
        const lastChar = emailSubSplits[0].charAt(emailSubSplits[0].length - 1);
        return `${firstChar}***${lastChar}@${emailSubSplits[1]}`;
    }
}
exports.StaticEmailHelpers = StaticEmailHelpers;
StaticEmailHelpers.emailRegex = /^([A-Za-z0-9_\-.%+/=?{|}~^])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
class DefaultEmailHelpers extends StaticEmailHelpers {
    constructor() {
        super(...arguments);
        this.emailRegex = DefaultEmailHelpers.emailRegex;
    }
    validateEmail(email) {
        return DefaultEmailHelpers.validateEmail(email, { emailRegex: this.emailRegex });
    }
    obfuscateEmail(email) {
        return DefaultEmailHelpers.obfuscateEmail(email);
    }
}
exports.DefaultEmailHelpers = DefaultEmailHelpers;
//# sourceMappingURL=DefaultEmailHelpers.js.map